export default {
  props: {
    id: Number,
    title: String,
    weight: Number,
    filename: String,
    price: Number,
    count: Number,
    category: String
  },
  setup() {}
};